var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125c6.87 0 8.496 4.589 8.88 6.76.109.612-.384 1.115-1.005 1.115H4.125c-.621 0-1.114-.503-1.005-1.114.385-2.172 2.01-6.76 8.88-6.761zM12 3a4.5 4.5 0 110 9 4.5 4.5 0 010-9z",
    fill: "currentColor"
  })));
}
SvgAccountFilled.displayName = 'AccountFilled';
export default SvgAccountFilled;